import type { ReactNode } from 'react';
import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import { AttentionIcon } from '../../../../../assets/icons';

import styles from '../textArea.module.scss';

/** Custom props */
export type TextAreaErrorProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** Style name to control the appearance of Alert title */
  errorTitleClassname?: string;

  /** Style name to control the appearance of Alert icon */
  errorIconClassName?: string;

  /** Flag to indicate if the error message should be shown */
  hasError: boolean;
};

export function Error(props: TextAreaErrorProps) {
  const { children, className, errorTitleClassname, errorIconClassName, hasError } = props;
  const classNames = cx(
    styles[toCamelCase('textArea', 'errorMessage')],
    hasError && styles[toCamelCase('textArea', 'errorMessage', 'show')],
    className,
  );
  return (
    <div className={classNames}>
      <AttentionIcon
        size={16}
        className={cx(styles[toCamelCase('textArea', 'errorIcon')], errorIconClassName)}
      />
      <span className={errorTitleClassname} data-testId="textArea-error">
        {children}
      </span>
    </div>
  );
}

export default Error;
